import { AiOutlineCheckCircle } from "react-icons/ai";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import '../container/sidebar.css'
import i18n from "../../translations/I18n";

const obj = {

    tb1_header: {
        row_1: [
            {
                title: "<p class='typo-14 typo-medium typo-white'>Phân loại</p>",
            },
            {
                title: "<p class='typo-14 typo-medium typo-white'>Giải thích</p>",
            },
            {
                title: "<p class='typo-14 typo-medium typo-white'>Dịch vụ</p>",
            },

        ]
    },
    tb1_content: {
        row_1: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Event Sourcing</p>",
            },
            {
                title: "<p class='typo-14'>Xây dựng kiến trúc tập trung vào sự kiện, hệ thống phân tán quy mô lớn, vận hành Event Store, dạng serverless</p>",
            },
            {
                title: "<p class='typo-14'>Event Sourcing</p>",
            },

        ],
        row_2: [
            {
                rowSpan: "4",
                title: "<p class='typo-14 typo-medium typo-black'>Identity and Access Management</p>",
            },
            {
                title: "<p class='typo-14'>Quản lý nhà cung cấp danh tính và thực hiện quản lý, xác thực danh tính và nhận diện khách hàng và client</p>",
            },
            {
                title: "<p class='typo-14'>Open ID Connect</p>",
            },


        ],
        row_3: [
            {
                title: "<p class='typo-14'>Xây dựng OAuth Server/Client để ủy quyền quyền hạn và kiểm soát truy cập thông qua phân quyền</p>",
            },
            {
                title: "<p class='typo-14'>OAuth</p>",
            },

        ],
        row_4: [
            {
                title: "<p class='typo-14'>Quản lý nhóm ID và sơ đồ tổ chức</p>",
            },
            {
                title: "<p class='typo-14'>Directory</p>",
            },

        ],
        row_5: [
            {
                title: "<p class='typo-14'>Phân quyền đọc, ghi, xóa Object theo Role, tạo danh sách kiểm soát truy cập (ACL)</p>",
            },
            {
                title: "<p class='typo-14'>Role based <br> Access Management</p>",
            },

        ],
        row_6: [
            {
                rowSpan: "4",
                title: "<p class='typo-14 typo-medium typo-black'>Messaging</p>",
            },
            {
                title: "<p class='typo-14'>Publisher định nghĩa và đăng ký message thành topic, phát sóng cho Subscriber</p>",
            },
            {
                title: "<p class='typo-14'>Topics</p>",
            },

        ],
        row_7: [
            {
                title: "<p class='typo-14'>Lọc các message theo topic đã nhận, lưu trữ và quản lý trong Queue của từng Subscriber</p>",
            },
            {
                title: "<p class='typo-14'>Queues</p>",
            },

        ],
        row_8: [
            {
                title: "<p class='typo-14'>Đăng ký các event trên server làm trigger, đẩy dữ liệu ra ngoài End Point qua Push</p>",
            },
            {
                title: "<p class='typo-14'>Webhooks</p>",
            },

        ],
        row_9: [
            {
                title: "<p class='typo-14'>Hỗ trợ định dạng Cron của Linux để sử dụng trong ứng dụng và Process</p>",
            },
            {
                title: "<p class='typo-14'>Scheduler</p>",
            },

        ],
        row_10: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Web RPC</p>",
            },
            {
                title: "<p class='typo-14'>Dịch vụ unary, streaming (Web Socket: server / client hai chiều), client TypeScript cho streaming</p>",
            },
            {
                title: "<p class='typo-14'>WebRPC</p>",
            },

        ],
        row_11: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Long-running</p>",
            },
            {
                title: "<p class='typo-14'>Trong Event Sourcing, module CUD hoạt động không đồng bộ, phản hồi máy chủ riêng biệt, chuyển trang tự động</p>",
            },
            {
                title: "<p class='typo-14'>Long-running</p>",
            },

        ],
        row_12: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Storage (S3)</p>",
            },
            {
                title: "<p class='typo-14'>Lưu trực tiếp tất cả các tập tin uploaded trong Cloud vào Object Storage</p>",
            },
            {
                title: "<p class='typo-14'>Core Storage</p>",
            },

        ],
        row_13: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Email</p>",
            },
            {
                title: "<p class='typo-14'>Gửi email hàng loạt và cung cấp Dashboard báo cáo trong Cloud</p>",
            },
            {
                title: "<p class='typo-14'>Vora Email</p>",
            },

        ],
        row_14: [
            {
                rowSpan: "2",
                title: "<p class='typo-14 typo-medium typo-black'>Process(Workflow)</p>",
            },
            {
                title: "<p class='typo-14'>Tự động hóa công việc, chuyển đổi trạng thái tự động, gửi tự động công việc đến người phụ trách</p>",
            },
            {
                title: "<p class='typo-14'>Business Process</p>",
            },

        ],
        row_15: [
            {
                title: "<p class='typo-14'>Tự động kích hoạt quy trình dựa trên nhấp chuột trong site liên kết qua email/SMS gửi đi</p>",
            },
            {
                title: "<p class='typo-14'>Journey Process</p>",
            },

        ],
        row_16: [
            {
                rowSpan: "2",
                title: "<p class='typo-14 typo-medium typo-black'>Rule</p>",
            },
            {
                title: "<p class='typo-14'>Thực thi tự động dựa trên trigger, hành động theo kết quả của Criteria (đúng hoặc sai)</p>",
            },
            {
                title: "<p class='typo-14'>Automation Rule</p>",
            },

        ],
        row_17: [
            {
                title: "<p class='typo-14'>Phân bổ tự động người phụ trách theo quy tắc</p>",
            },
            {
                title: "<p class='typo-14'>Assignment Rule</p>",
            },

        ],
        row_18: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Rate Limiting</p>",
            },
            {
                title: "<p class='typo-14'>Bảo vệ ứng dụng trước các yêu cầu khách hàng đột ngột gia tăng không dự đoán được và không ổn định</p>",
            },
            {
                title: "<p class='typo-14'>Rate Limiting</p>",
            },

        ],
        row_19: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Simple URL shortner</p>",
            },
            {
                title: "<p class='typo-14'>Chuyển đổi URL dài thành URL ngắn cá nhân, cung cấp nhận dạng người nhận và báo cáo</p>",
            },
            {
                title: "<p class='typo-14'>SUS</p>",
            },

        ]
    },

    tb2_header: {
        row_1: [
            {
                title: "",
            },
            {
                title: "",
            },

        ]
    },
    tb2_content: {
        row_1: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Identity (Nhận diện)</p>",
            },
            {
                title: "<p class='typo-14'>Thành viên (Principal), xác định danh tính (Id) – tên người dùng, số tài khoản</p>",
            },

        ],
        row_2: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Authentication (Xác thực)</p>",
            },
            {
                title: "<p class='typo-14'>Chứng minh danh tính đã trình bày có đúng hay không – mật khẩu, sinh trắc học, thẻ thông minh, v.v</p>",
            },

        ],
        row_3: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Authorization (Ủy quyền)</p>",
            },
            {
                title: "<p class='typo-14'>Quá trình cho phép truy cập vào đối tượng (Object) cụ thể</p><p class='typo-14'>-- Danh sách kiểm soát truy cập (ACL: Access Control List)</p>",
            },

        ],
        row_4: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Access Control (Kiểm soát truy cập)</p>",
            },
            {
                title: "<p class='typo-14'>Nhận dạng -> Xác thực -> Kiểm soát quyền truy cập vào các hệ thống hoặc thông tin cụ thể đối với người dùng đã được ủy quyền</p><p class='typo-14'>Các loại kiểm soát truy cập: Trong nhiều loại, hỗ trợ RBAC (Role Based Access Control)</p>",
            },

        ],
        row_5: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>RBAC (Kiểm soát truy cập dựa trên vai trò)</p>",
            },
            {
                title: "<p class='typo-14'>Gán vai trò (Role) cho thành viên (Principal) đối với tài nguyên (Resource)</p><p class='typo-14'>và cấp quyền (Permission) cho các vai trò đã định sẵn, theo từng tài nguyên.</p><p class='typo-14'> Quyền: Ghi (Write), Xóa (Delete), Cập nhật (Update), Liệt kê (List), Xem (Get)</p>",
            },

        ],
        row_6: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>IdP (ID Provider)</p>",
            },
            {
                title: "<p class='typo-14'>Nhà cung cấp danh tính: tạo, lưu trữ, quản lý ID kỹ thuật số.</p><p class='typo-14'>Có thể tự xác thực người dùng hoặc cung cấp xác thực qua các dịch vụ bên thứ ba như Google, Facebook, v.v.</p>",
            },

        ],
    },

    tb3_header: {
        row_1: [
            {
                title: "<p class='typo-14 typo-medium typo-white'>Phân loại</p>",
            },
            {
                title: "<p class='typo-14 typo-medium typo-white'>Access Token (OAuth)</p>",
            },
            {
                title: "<p class='typo-14 typo-medium typo-white'>ID Token (OIDC)</p>",
            },
        ]
    },
    tb3_content: {
        row_1: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Quyền truy cập tài nguyên</p>",
            },
            {
                title: "",
                icon: <AiOutlineCheckCircle className="icon-check" />,
            },
            {
                title: "",
                icon: <AiOutlineCloseCircle className="icon-close" />,
            },
        ],
        row_2: [
            {
                title: "<p class='typo-14 typo-medium typo-black'>Thông tin nhận dạng người dùng</p>",
            },
            {
                title: "",
                icon: <AiOutlineCloseCircle className="icon-close" />,
            },
            {
                title: "",
                icon: <AiOutlineCheckCircle className="icon-check" />,
            },
        ],
    },

    tb4_header: {
        row_1: [
            {
                title: "항목",
            },
            {
                title: "내용",
            },
            {
                title: "가격(원)",
            },
        ]
    },
    tb4_content: {
        row_1: [
            {
                title: "API 요청",
            },
            {
                title: "최초 ________ 건까지",
            },
            {
                title: "00 원",
            },
        ],
        row_2: [
            {
                title: "",
            },
            {
                title: "이후 ________ 건까지",
            },
            {
                title: "00 원",
            },
        ],
    },
    tb5_header: {
        row_1: [
            {
                title: "항목",
            },
            {
                title: "내용",
            },
            {
                title: "가격(원)",
            },
        ]
    },
    tb5_content: {
        row_1: [
            {
                title: "Event Store",
            },
            {
                title: "최초 ________ 건까지",
            },
            {
                title: "00 원",
            },
        ],
        row_2: [
            {
                title: "",
            },
            {
                title: "이후 ________ 건까지",
            },
            {
                title: "00 원",
            },
        ],
    },

    tb6_header: {
        row_1: [
            {
                title: "항n",
            },
            {
                title: "건 (월비용)",
            },
            {
                title: "가격(원)",
            },

        ]
    },
    tb6_content: {
        row_1: [
            {
                title: "클라우드 내부간 Push",
            },
            {
                title: "최초 ________ 건까지",
            },
            {
                title: "00 원",
            },

        ],
        row_2: [
            {
                rowSpan: "2",
                title: "외부 Push",
            },
            {
                title: "백만 건까지",
            },
            {
                title: "00 원",
            },

        ],
        row_3: [
            {
                title: "이후 십만건당",
            },
            {
                title: "1,000 원",
            },

        ],
    },

    tb7_header: {
        row_1: [
            {
                Cols50: "True",
                title: "<p class='typo-14 typo-medium typo-white'>Phương pháp thông thường</p>",
            },
            {
                title: "<p class='typo-14 typo-medium typo-white'>Phương pháp Long-running</p>",
            },
        ],
    },
    tb7_content: {
        row_1: [
            {
                bold: "False",
                title: "<p class='typo-14'>Tất cả mã chạy theo cách đồng bộ.</p><p class='typo-14'>Đồng bộ có nghĩa là mã lần lượt thực thi, chờ cho đến khi đoạn mã trước đó hoàn tất.</p>",
            },
            {
                title: "<p class='typo-14'>Nếu xử lý mã bất đồng bộ, các tác vụ sẽ được xử lý trong nền của server</p><p class='typo-14'> Không chờ đợi kết thúc công việc, cứ chạy đoạn mã tiếp theo.</p>",
            },
        ],
    },

    tb8_header: {
        row_1: [
            {
                title: "항옥",
            },
            {
                title: "API 사용건",
            },
            {
                title: "웹 접속건",
            },
            {
                title: "가격(원)",
            },
        ],
    },
    tb8_content: {
        row_1: [
            {
                title: "클라우드 사용고객",
            },
            {
                title: "________________",
            },
            {
                title: "_______ /월 건당",
            },
            {
                title: "00 원",
            },
        ],
        row_2: [
            {
                title: "외부 - Vora Works",
            },
            {
                title: "________________",
            },
            {
                title: "_______ /월 건당",
            },
            {
                title: "00 원",
            },
        ],
    },

    tb9_header: {
        row_1: [
            {
                title: "&nbsp;",
            },
            {
                title: "Topic",
            },
            {
                title: "Queue",
            },
            {
                title: "Channel",
            },
        ],
    },
    tb9_content: {
        row_1: [
            {
                title: "Delivery",
            },
            {
                title: "<div style='text-align:center'>At Least Once (Exactly Once) <br> <span style='color: #48A7FC; font-size: 14px'>(Committing Offset 방식)</span> <img src='https://hanbiro.com/cloud/images/cloud/question.svg' width='20px'></img></div>"
            },
            {
                title: "<div style='text-align:center'>At Least Once (Exactly Once) <br> <span style='color: #48A7FC; font-size: 14px'>(Ack Reply 방식)</span> <img src='https://hanbiro.com/cloud/images/cloud/question.svg' width='20px'></img></div>"
            },
            {
                title: "<div style='text-align:center'>At Most Once</div>",
            }
        ],
        row_2: [
            {
                title: "Storage",
            },
            {
                title: "<div style='text-align:center'>Disk</div>",
            },
            {
                title: "<div style='text-align:center'>Disk</div>",
            },
            {
                title: "<div style='text-align:center'>In Memory</div>",
            },
        ],
        row_3: [
            {
                title: "Ordering",
            },
            {
                title: "<div style='text-align:center'>순서보장</div>",
            },
            {
                title: "<div style='text-align:center'>순서보장안함</div>",
            },
            {
                title: "<div style='text-align:center'>X</div>",
            },
        ],
        row_4: [
            {
                title: "Consumer",
            },
            {
                title: "<div style='text-align:center'>Pub / Sub</div>",
            },
            {
                title: "<div style='text-align:center'>1:1</div>",
            },
            {
                title: "<div style='text-align:center'>Fan Out (Broadcast)</div>",
            },
        ],
    },
    tb10_header: {
        row_1: [
            {
                Cols50: "True",
                title: "Pull"
            },
            {
                title: "Push"
            },
        ],
    },
    tb10_content: {
        row_1: [
            {
                bold: "False",
                title: "<div style='text-align:'>Streaming Pull 지원. <br> Consumer 가 API 를 호출해서 Message 를 가져감.</div>"
            },
            {
                title: "<div style='text-align:'>Worker가 Message를 받아 GRPC Unary나 URL Get/Post를 보냄.</div>"
            }
        ]
    },
};


export default obj;